import { callApi } from 'utils/api/callApi'
import { FP_ENDPOINTS } from 'apps/fleet-planner/config'
import * as Types from 'apps/fleet-planner/types'

export interface IFetchCustomerParams {
  filters?: {
    name?: string
  }
  pageSize?: number
  pageNumber?: number
  sortField?: string
  sortOrder?: string
}

/**
 * Fetch all customers, with optional query params
 * @method GET
 * @see https://fp-staging.transfix.io/api-docs/index.html
 */
export const fetchCustomers = (
  params: IFetchCustomerParams = {}
): Promise<Types.IFetchCustomersResponse> => {
  return callApi({
    endpoint: FP_ENDPOINTS.customers,
    method: 'GET',
    params: {
      ...params,
    },
  })
}

/**
 * Creates a new customer entity
 * @method POST
 * @param {INewCustomer} customer - new customer object
 * @see https://fp-staging.transfix.io/api-docs/index.html
 */
export const createNewCustomer = (
  customer: Pick<Types.ICustomer, 'name' | 'notes' | 'contacts'>
): Promise<Types.ICreateNewCustomerResponse> => {
  return callApi({
    endpoint: FP_ENDPOINTS.customers,
    method: 'POST',
    body: {
      customer,
    },
  })
}

/**
 * Update existing customer entity
 * @method PUT
 * @param {string} customerId
 * @param {INewCustomer} customer
 */
export const updateCustomer = (
  customerId: string,
  customer: Partial<Types.ICustomer>
): Promise<Types.ICreateNewCustomerResponse> => {
  return callApi({
    endpoint: `${FP_ENDPOINTS.customers}/${customerId}`,
    method: 'PUT',
    body: customer,
  })
}
